import SuccessCheckmarkIcon from '../Icons/SuccessCheckmarkIcon';

export default function SuccessCheckmark() {
  return <SuccessCheckmarkIcon />;
}
